<template>
<div>
  <v-toolbar >
    <v-btn outlined small
      v-for="(action, index) in actions"
      :key="action.id"
      @click="setComponent(index)"
      class="ml-3" color="primary" >{{action.cta}}</v-btn>
    <!-- <v-btn icon ><v-icon>mdi-close</v-icon></v-btn> -->
  </v-toolbar>

  <v-dialog fullscreen
    v-if="practitioner"
    v-model="dialogvisible" >
    <v-card tile >
      <!-- <pre v-text="practitioner" class="caption grey lighten-4 pa-3" /> -->
      <v-card-title class="overline grey lighten-4 py-1" >
        Configuration for {{fullName}}
        <v-spacer/>
        <v-btn @click="dialogvisible=false" icon small ><v-icon small>mdi-close</v-icon></v-btn>
      </v-card-title>
      <manage
        v-if="activeComponent && activeComponent.id && practitionerId"
        title=""
        :page="activeComponent.id"
        :initial-practitioner-id="practitionerId"
        :practitioner-selectable="false"
        :with-crumbs="false" />

    </v-card>

  </v-dialog>
</div>
</template>
<script>
import Manage from '@/views/Manage.vue'
import MemberHours from './MemberHours.vue'
import MemberPermissions from './MemberPermissions.vue'
import MemberAppointmentTypes from './MemberAppointmentTypes.vue'

export default {
  name: 'MemberActions',
  // components: {MemberHours, MemberPerrmissions, MemberAppointmentTypes},
  components: {Manage},
  props: {
    practitioner: { type: Object, required: true },
    businessId: { type: [String, Number], required: true },
    visible: { type: Boolean, default: false }
  },
  data () {
    return {
      dialogvisible: false,
      activeComponent: null
    }
  },
  methods: {
    setComponent (index) {
      this.activeComponent = this.actions[index]
      this.dialogvisible = true
    }
  },
  watch: {
    visible () {
      if (this.visible === true) {
        this.setComponent(0)
      }
    }
  },
  computed: {
    practitionerId () {
      let id = this.getObjectPath(this.practitioner, 'id')
      if (!id) { return this.getObjectPath(this.practitioner, 'user.id') }
      return id
    },
    fullName () {
      if (this.practitioner && this.practitioner.user) {
        let u = this.practitioner.user
        return `${u.first_name} ${u.last_name}`
      }
      return this.getObjectPath(this.practitioner, 'full_name')
    },
    actions () {
      if (!this.practitioner) { return [] }
      return [
        {
          id: 'permissions',
          cta: 'Permissions',
          component: MemberPermissions,
          args: { }
        },
        {
          id: 'hours',
          cta: 'Operation hours',
          component: MemberHours,
          args: {
            spaceId: this.practitioner.service,
            withClose: true
          }
        },
        {
          id: 'types',
          cta: 'Appointment Types',
          component: MemberAppointmentTypes,
          args: { }
        }
      ]
    }
  }
}
</script>